import { useEffect, useState } from "react";
import FormTemplate from "../../templates/FormTemplate";
import { Box, Grid, Stack } from "@mui/material";
import { SettingsService } from "../../../services/api";
import { useGlobalContext } from "../../../stores/Global";
import useRefresh from "../../../hooks/useRefresh";
import { useTranslation } from "react-i18next";
import ItemList from "../../molecules/ItemList";
import useBreakpoint from "../../../hooks/useBreakpoint";
import { useMutation, useMutationState } from "@tanstack/react-query";
import { useNavigate } from "react-router";

export default function CitiesSettingsPage() {
  const breakpoint = useBreakpoint();
  const { t } = useTranslation("Settings");
  const { context } = useGlobalContext();
  const refresh = useRefresh();
  const navigate = useNavigate();

  const handleClose = () => {
    navigate(-1);
  };

  const [loading] = useMutationState({
    filters: { mutationKey: ["settings"] },
    select: (mutation) => mutation.state.status === "pending",
  });

  const [cities, setCities] = useState<string[]>([]);

  const handleSubmit = async () => {
    if (!context.settings) return;
    await SettingsService.updateSettings({
      appSettings: {
        ...context.settings,
        cities,
      },
    });
    refresh();
  };

  useEffect(() => {
    if (!context.settings) return;
    setCities(context.settings.cities);
  }, [context.settings]);

  return (
    <FormTemplate
      title={t("Cities.Title")}
      disableCancelButton
      loading={loading}
      onCancel={handleClose}
      submitButtonText={t("Save")}
    >
      <Grid
        component={Stack}
        display="flex"
        flexDirection="column"
        size={{ xs: 12, md: 3 }}
        maxHeight={breakpoint.md ? 1 : undefined}
      >
        <Stack
          flexGrow={1}
          sx={{ overflowY: "auto", px: 0.5, overflowX: "hidden" }}
        >
          <ItemList
            label={t("AddCity")}
            reorderable
            unique
            confirmDeletion
            items={cities}
            onChange={(list) => setCities(list)}
          />
          <Box mb={4} />
        </Stack>
      </Grid>
    </FormTemplate>
  );
}
